import TtamCreativeGeneralDeeplinkSwitch from './switch/index.vue';
import TtamCreativeGeneralDeeplinkInput from './input/index.vue';
import TtamCreativeGeneralDeeplinkCheck from './check-button/index.vue';
import TtamCreativeGeneralDeeplinkPreviewDialog from './preview-dialog/index.vue';

import * as hooks from './hooks';
export default {
  TtamCreativeGeneralDeeplinkSwitch,
  TtamCreativeGeneralDeeplinkInput,
  TtamCreativeGeneralDeeplinkCheck,
  TtamCreativeGeneralDeeplinkPreviewDialog,
  ...hooks,
};
